<template>
<div>
  <v-app v-if="user">
    <layout></layout>
    <PageFooter></PageFooter>
  </v-app>
   <router-view v-else> </router-view>
</div>
</template>

<script>
  import Layout from "./components/layout";
  import PageFooter from "./components/layout/PageFooter";

export default {
  name: 'App',

  components: {
    Layout,
    PageFooter
  },

  data: () => ({
    user: localStorage.getItem('user')
  }),
  mounted() {
    console.log('nemanja nemko ' + this.user)
  }
};
</script>
